"use client";
import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Fade,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Poppins } from "next/font/google";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import {
  CFormHelperText,
  ContainedButton,
  CTextButton,
  CustomFormLabel,
} from "./CustomStyles";
import PasswordField from "./CustomFields/PasswordField";
import axios from "axios";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import { useRouter } from "next/navigation";
import { jwtDecode } from "jwt-decode";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const ResendTypographyStyles = {
  fontSize: "14px",
  fontWeight: 500,
  textAlign: "center",
  fontFamily: poppins.style.fontFamily,
  color: "#5C677D",
  "& .timer": { color: "#004FE0" },
};

const forgotPassButtonStyle = {
  p: 0,
  m: 0,
  height: "1rem",
  width: "fit-content",
  color: "#006A4E",
  justifyContent: "flex-start",
};

const CreatePassword = (props) => {
  const {
    email,
    phone,
    signInWith,
    drawerTitle,
    handleClose,
    setAuthSteps,
    setAuthState,
    handleSubmitFn,
    initializeAgain,
    handleForgotPassFn,
    setPasswordToParent,
    showToastWithMessage,
    new_teaching_info_token,
  } = props;

  const router = useRouter();

  const [alertOpen, setAlertOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [isStrongPassword, setIsStrongPassword] = useState(false);
  const [userDataObject, setUserDataObject] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  // const [password, setPassword] = useState("");
  // const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const isPasswordEmpty = true;

  // * ==== * //

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [error, setError] = useState(false);

  const handlePasswordChange = (newPassword) => {
    setPasswordError("");
    setPassword(newPassword);
    if (!newPassword || newPassword.length < 8 || !/\d/.test(newPassword)) {
      setError(true);
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (new_teaching_info_token) {
      let newUserDataObject = {};
      atob(new_teaching_info_token)
        .split("&")
        .map((data) => {
          let dataWithKeyVal = data.split("=");
          newUserDataObject[dataWithKeyVal[0]] = dataWithKeyVal[1];
          setUserDataObject(newUserDataObject);
          localStorage.setItem(
            "newTeachingAccount",
            JSON.stringify(newUserDataObject)
          );
        });
    }
  }, [new_teaching_info_token]);

  useEffect(() => {
    console.log(userDataObject, "userDataObject");
  }, [userDataObject]);

  useEffect(() => {
    setPasswordToParent(password);
  }, [password]);

  const handleSubmit = () => {
    if (!password || password.length < 8 || !/\d/.test(password)) {
      setError(true);
      return;
    }
    // Proceed with form submission or next step
    console.log("Form submitted with password:", password, 33);
  };

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  const sendPasswordForEmail = () => {
    if (password.length == 0) {
      setPasswordError("Password is required");
      setShowLoader(false);
      return false;
    }
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["password"] = password;
        postData["user_role"] = "student";
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForNewEmail`, postData)
          .then((response) => {
            setShowLoader(false);
            console.log(response?.data, "response");

            if (!response?.data?.error) {
              // if (props?.invite_token && props?.invite_token != "") {
              //   setAuthSteps(3);
              // } else {
              //   showToastWithMessage("Code sent");
              //   setAuthSteps(2);
              // }
              showToastWithMessage("Code sent");
              setAuthSteps(2);
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const sendPasswordForMobile = () => {
    if (password.length == 0) {
      setPasswordError("Password is required");
      setShowLoader(false);
      return false;
    }
    let postData = {};
    let fromBecomeATeacher = sessionStorage.getItem("from_become_a_teacher")
    fromBecomeATeacher = fromBecomeATeacher ? Boolean(fromBecomeATeacher) : false 
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["phone"] = `${phone}`;
        postData["from_become_a_teacher"] = fromBecomeATeacher;
        postData["password"] = password;
        postData["user_role"] = "student";
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForNewPhone`, postData)
          .then((response) => {
            if (response?.data?.error) {
              setAlertSeverity("error");
              setAlertMessage("Something wen wrong");
              setAlertOpen(true);
            } else {
              const userData = {
                id: response?.data?.body?.id,
                firstName: response?.data?.body?.first_name,
                lastName: response?.data?.body?.last_name,
                email: response?.data?.body?.email,
                phone_number: response?.data?.body?.phone_number,
                image: response?.data?.body?.image,
                userRole: response?.data?.body?.user_role,
                from_become_a_teacher : response?.data?.body?.from_become_a_teacher
              };
              setErrorStatus(false);
              sessionStorage.removeItem("from_become_a_teacher");


              const decoded = jwtDecode(response?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);

              // set user data and user access token
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("userToken", response?.data?.token);
              localStorage.setItem("jwtToken", response?.data?.jwt_token);

              // set user as authorized
              localStorage.setItem("userAuthenticated", true);
              const userVerified =
                response?.data?.body?.email_verified_at?.length == 0
                  ? false
                  : true;
              localStorage.setItem("userVerified", userVerified);

              // show success message
              setAlertSeverity("success");
              setAlertMessage("Sign in Success!");
              setAlertOpen(true);

              localStorage.setItem(
                "profile_completed",
                response?.data?.profile_completed
              );
              // setAuthState(false);

              // console.log(props.organization_invitation, 345);
              if (props.organization_invitation) {
                localStorage.setItem("invite_token", props.invite_token);
                router.push("/create-new-teaching-account");
              } else {
                router.push("/onboarding");
                setTimeout(() => {
                  if (props.active_modal) {
                    window.location.href = `/`;
                  } else {
                    router.refresh()
                  }
                }, 2000);
              }
              // setShowLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setShowLoader(false);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const newUserSignUpHandler = async () => {
    if (password.length == 0) {
      setPasswordError("Password is required");
      setShowLoader(false);
      return false;
    }
    let postData = {};
    ///===================== recapcha ==============================///
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        // add aditional data
        postData["user_role"] = "student";
        postData["password"] = password;
        postData["email"] = userDataObject?.email;
        postData["token"] = token;

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForNewEmailDirectRegister`, postData)
          .then((response) => {
            if (response?.data?.error) {
              setAlertSeverity("error");
              setAlertMessage("Something wen wrong");
              setAlertOpen(true);
            } else {
              const userData = {
                id: response?.data?.body?.id,
                firstName: response?.data?.body?.first_name,
                lastName: response?.data?.body?.last_name,
                email: response?.data?.body?.email,
                phone_number: response?.data?.body?.phone_number,
                image: response?.data?.body?.image,
                userRole: response?.data?.body?.user_role,
              };
              setErrorStatus(false);

              const decoded = jwtDecode(response?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);

              // set user data and user access token
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("userToken", response?.data?.token);
              localStorage.setItem("jwtToken", response?.data?.jwt_token);

              // set user as authorized
              localStorage.setItem("userAuthenticated", true);
              const userVerified =
                response?.data?.body?.email_verified_at?.length == 0
                  ? false
                  : true;
              localStorage.setItem("userVerified", userVerified);

              // show success message
              setAlertSeverity("success");
              setAlertMessage("Sign in Success!");
              setAlertOpen(true);

              localStorage.setItem(
                "profile_completed",
                response?.data?.profile_completed
              );
              setAuthState(false);

              setShowLoader(false);
              // console.log(props.organization_invitation, 345);
              if (props.organization_invitation) {
                localStorage.setItem("invite_token", props.invite_token);
                router.push("/create-new-teaching-account");
              } else {
                initializeAgain()
              }
            }
          })
          .catch((err) => {
            if (err.response.data.message) {
              toast.error(err.response.data.message);
            }
          });
      } catch (error) {
        console.error("Error:", error);
      }
    });
  };

  const continueHandler = () => {
    setShowLoader(true);
    if (!isStrongPassword) {
      setShowLoader(false);
      return false;
    }
    if (signInWith == "email") {
      if (new_teaching_info_token != "" && userDataObject) {
        newUserSignUpHandler();
      } else {
        sendPasswordForEmail();
      }
    } else {
      sendPasswordForMobile();
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "32px" }}>
        {/* {isPasswordEmpty && (
          <Fade in={isPasswordEmpty}>
            <Alert
              severity="warning"
              icon={<InfoOutlinedIcon />}
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#0B132B",
                borderRadius: "8px",
                alignItems: "center",
                fontFamily: poppins.style.fontFamily,
              }}
            >
              Incorrect phone number and / or password. <br /> You can try again
              or reset your password
            </Alert>
          </Fade>
        )} */}
        {/* <PasswordField
          placeholder="Password"
          value={password}
          onChange={handlePasswordChange}
          error={error}
          helperText={error ? "Password too short" : ""}
        /> */}
        <Box>
          <CustomFormLabel>Enter new password</CustomFormLabel>
          <PasswordField
            placeholder="Enter your password"
            value={password}
            onChange={handlePasswordChange}
            error={passwordError != ""}
            helperText={passwordError}
            setIsStrongPassword={setIsStrongPassword}
          />

          {passwordError != "" && (
            <CFormHelperText sx={{ color: "#BA1A1A" }}>
              {passwordError}
            </CFormHelperText>
          )}
        </Box>
        <Box>
          <ContainedButton
            variant="contained"
            fullWidth
            endIcon={<ArrowForwardRoundedIcon />}
            // onClick={handleSubmitFn ? handleSubmitFn : undefined}
            onClick={(e) => continueHandler()}
          >
            Continue
          </ContainedButton>
          <div className="CreateAccountTermText">
            <Typography
              sx={{
                fontSize: "12px",
                fontFamily: poppins.style.fontFamily,
                color: "#0B132B !important",
                "& a": {
                  color: "#004FE0",
                  textDecoration: "none",
                  fontFamily: poppins.style.fontFamily,
                },
                "& a:hover": { textDecoration: "underline" },
              }}
            >
              By continuing, I agree with Takbir's{" "}
              <a
                href="https://mytakbir.com/terms-of-service-main"
                target="_blank"
              >
                Terms
              </a>{" "}
              and{" "}
              <a
                href="https://mytakbir.com/privacy-policy-main"
                target="_blank"
              >
                Privacy policy
              </a>
              .
            </Typography>
          </div>
        </Box>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default CreatePassword;
